import { z } from 'zod'

export const GoogleAudienceType = {
  remarketing: 'remarketing',
  custom: 'custom',
  combined: 'combined',
  saved: 'saved',
}

const googleAudienceItemSchema = z
  .object({
    id: z.string(),
    resource_name: z.string(),
    name: z.string(),
    type: z.string().nullable().optional(),
    audience_type: z.string(),
    size_for_display: z.number().nullable().optional(),
  })
  .passthrough()

export const googleAudiencesResponseSchema = z.array(googleAudienceItemSchema)
